module.exports = __webpack_public_path__ + "static/media/car.2132b9d1.svg";